import Api from '../../../helpers/Api';

export const SET_PARTNERS_DATA = 'SET_PARTNERS_DATA';
const setPartnersData = (partnersData) => ({
    type: SET_PARTNERS_DATA,
    partnersData,
});

export const SET_IS_LOADING_PARTNERS = 'SET_IS_LOADING_PARTNERS';
const setIsLoading = (isLoading) => ({
    type: SET_IS_LOADING_PARTNERS,
    isLoading,
});


// get all the partners data from the api and set it in the store
export const getPartnersDataIfNeeded = () => (dispatch, getState) => {
    const { partnersData } = getState().partners;

    if (partnersData.length === 0) {
        return Api.progressGet(dispatch, 'api/v1/getPartnersData')
            .then((json) => {
                if (json.status !== 'success') {
                    throw 'error from server';
                } else {
                    dispatch(setPartnersData(json.data));

                    dispatch(setIsLoading(false));
                }
            }).catch((err) => {
                // eslint-disable-next-line no-console
                console.error(err);

                dispatch(setIsLoading(false));
            });
    }

    return Promise.resolve(1);
};
